<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">Book Your Appointment</h2>
      <button class="close-button" (click)="onClose()" type="button">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 1L1 13M1 1L13 13" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Modal Description -->
    <p class="modal-description">
      Schedule your car wash at a time that's convenient for you. We'll make sure your vehicle gets the care it deserves.
    </p>

    <!-- Modal Form -->
    <form class="appointment-form" (ngSubmit)="onSchedule()">
      <!-- Full Name -->
      <div class="form-group">
        <label for="fullName">Full Name</label>
        <input
          type="text"
          id="fullName"
          name="fullName"
          [(ngModel)]="formData.fullName"
          placeholder="e.g. John David"
          required>
      </div>

      <!-- Email -->
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          [(ngModel)]="formData.email"
          placeholder="john@example.com"
          required>
      </div>

      <!-- Phone Number -->
      <div class="form-group">
        <label for="phoneNumber">Phone Number</label>
        <input
          type="tel"
          id="phoneNumber"
          name="phoneNumber"
          [(ngModel)]="formData.phoneNumber"
          placeholder="(123) 456-7890"
          required>
      </div>

      <!-- Service Type -->
      <div class="form-group">
        <label for="serviceType">Service Type</label>
        <select
          id="serviceType"
          name="serviceType"
          [(ngModel)]="formData.serviceType"
          required>
          <option value="" disabled>Select a Service</option>
          <option *ngFor="let option of serviceOptions; trackBy: trackByValue" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <!-- License Plate -->
      <div class="form-group">
        <label for="licensePlate">License Plate</label>
        <input
          type="text"
          id="licensePlate"
          name="licensePlate"
          [(ngModel)]="formData.licensePlate"
          placeholder="e.g. HWC246"
          required>
      </div>

      <!-- Preferred Date -->
      <div class="form-group">
        <label for="preferredDate">Preferred Date</label>
        <app-custom-date-picker
          name="preferredDate"
          [(ngModel)]="formData.preferredDate"
          placeholder="Select date"
          [showTime]="false"
          [showFooterButtons]="false"
          [disabled]="isSubmitting">
        </app-custom-date-picker>
      </div>

      <!-- Preferred Time -->
      <div class="form-group">
        <label for="preferredTime">Preferred Time</label>
        <div class="time-picker-wrapper">
          <input 
            type="hidden"
            name="preferredTime"
            [(ngModel)]="formData.preferredTime"
            required>
          <div 
            class="time-picker-input"
            [class.active]="isTimeDropdownOpen"
            [class.has-value]="formData.preferredTime"
            (click)="toggleTimeDropdown()">
            <span [class.placeholder]="!formData.preferredTime">{{ getDisplayTime() }}</span>
            <svg class="clock-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 1.75C4.1 1.75 1.75 4.1 1.75 7C1.75 9.9 4.1 12.25 7 12.25C9.9 12.25 12.25 9.9 12.25 7C12.25 4.1 9.9 1.75 7 1.75ZM7 11.0833C4.83333 11.0833 3.08333 9.33333 3.08333 7.16667C3.08333 5 4.83333 3.25 7 3.25C9.16667 3.25 10.9167 5 10.9167 7.16667C10.9167 9.33333 9.16667 11.0833 7 11.0833Z" fill="#6B7280"/>
              <path d="M7.58333 4.66667V7.58333L9.91667 8.75" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="time-dropdown" *ngIf="isTimeDropdownOpen">
            <div class="time-list">
              <div 
                *ngFor="let time of timeOptions; trackBy: trackByValue"
                class="time-option"
                [class.selected]="formData.preferredTime === time"
                (click)="selectTime(time)">
                {{ time }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Notes -->
      <div class="form-group full-width">
        <label for="notes">Special Requests or Notes</label>
        <textarea
          id="notes"
          name="notes"
          [(ngModel)]="formData.notes"
          placeholder="Any special request or vehicle details"
          rows="4"></textarea>
      </div>

      <!-- Success Message -->
      <div class="message success-message" *ngIf="successMessage">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ successMessage }}</span>
      </div>

      <!-- Error Message -->
      <div class="message error-message" *ngIf="errorMessage">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5.33333V8M8 10.6667H8.00667M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z" stroke="#EF4444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button type="button" class="btn-cancel" (click)="onClose()" [disabled]="isSubmitting">Cancel</button>
        <button type="submit" class="btn-schedule" [disabled]="!isFormValid() || isSubmitting">
          <span *ngIf="!isSubmitting">Schedule</span>
          <span *ngIf="isSubmitting">Scheduling...</span>
        </button>
      </div>
    </form>
  </div>
</div>

